/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa formsISPALBANIA
 *
 */
Intesa.FormsISPALBANIA = function () {
	
	//this.score1 = 0;
	//this.score2 = 0;
	
	/*var sessionScore1 = sessionStorage.getItem('score1') || '';
	if (sessionScore1.length > 0) {
		var JSON_score1 = parseInt(JSON.parse(sessionScore1));
		this.score1 = JSON_score1;
	}
	var sessionScore2 = sessionStorage.getItem('score2') || '';
	if (sessionScore2.length > 0) {
		var JSON_score2 = parseInt(JSON.parse(sessionScore2));
		this.score2 = JSON_score2;
	}*/

	var myForm = $('input[name="myForm"]').val();
	var isPBZ = $('html').attr('data-bank') == 'PBZ';
	var isCIB = $('html').attr('data-bank') == 'CIB';
	var isSLO = $('html').attr('data-bank') == 'ISPSLOVENIA';
	var isBIB = $('html').attr('data-bank') == 'BIB';
	var isALB = $('html').attr('data-bank') == 'ISPALBANIA';
	
	var exchangeRate;

	/**
	 * Local variables
	 *
	 */
	var formsISPALBANIA = this;

	/**
	 * Init component
	 *
	 */
	this.init = function () {

		if (isCIB || isSLO || isPBZ || isBIB) {
			window.intesa.formsISPALBANIA = null;
			return; 
		}


		function recaptchaCallback() {
			$("#recaptchainput").val('true');
			setTimeout(function () {
				$('form[name="formThanksMortgage"]').parsley().validate();
				formsISPALBANIA.checkPrivacy();
			}, 500);
		}

		function validationCallback() {
			setTimeout(function () {
				$('form[name="formThanksMortgage"]').parsley().validate();
				forms.checkPrivacy();
			}, 500);
		}

		window.recaptchaCallback = $("input[name='recaptchaKey']").length >= 1 ? validationCallback : recaptchaCallback;

		formsISPALBANIA.sessionMortgage = [{
			"form1": {
				"loanPurpose": "",
				"borrowingProcess": "",
				"borrowingProcessFirstPossibility": "",
				"borrowingProcessSecondPossibility": "",
				"borrowingProcessThirdPossibility": "",
				"permanentAddress": "",
				"adultAge": "",
				"incomeType": "",
				"incomeTypeOther": "",
				"refinancedLoanAmount": "",
				"refinancedLoanCurrency": "",
				"investmentAmount": "",
				"investmentCurrency": "",
			}, "form2": {
				"monthlyIncome": "",
				"monthlyIncomeCurrency": "",
				"householdMembers": "1",
				"previousLoan": "",
				"previousLoanInstallment": "",
				"previousLoanInstallmentCurrency": "",
				"creditCard": "",
				"creditCardLimit": "",
				"creditCardLimitCurrency": "",
				"overdraft": "",
				"overdraftLimit": "",
				"overdraftLimitCurrency": "",
			}, "form3": {
				"valueOfProperty": "",
				"valueOfPropertyCurrency": "",
				"collateral": "",
				"collateralValue": "",
				"collateralValueCurrency": "",
			}, "form4": {
				"referralSource": "",
				"partner": "",
				"promoCodePartner": "",
				"promoCodeBankCustomer": "",
				"referralSourceOther": "",
			},
			"typeOfAppointment": "",
			"loanPurposeIndex": "0",
		}];

		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);
			formsISPALBANIA.sessionMortgage = JSON_Obj;
		}
		
		formsISPALBANIA.setProductName();
		
		// formsISPALBANIA.setMagnificaCss();		// SET MAGNIFICA CSS
		
		if($('[name="linkDefaultRetailMortgage"]').length > 0){
			
			formsISPALBANIA.setStartingPage();
			
		}

		if ($('[data-component-r="formStep1Mortagage"]').length > 0 || $('[data-component-r="formStep2Mortagage"]').length > 0 || $('[data-component-r="formStep3Mortagage"]').length > 0 || $('[data-component-r="formStep4Mortagage"]').length > 0) {
			formsISPALBANIA.refreshStep(1);
			formsISPALBANIA.toggleAccordion();
			formsISPALBANIA.formStep1Mortagage();
			if (sessionStorage.getItem('back') != 'true') {
				$('.rstep1').removeClass('rhide');
			}
			formsISPALBANIA.setActiveInput();
			formsISPALBANIA.setActiveImport();
			formsISPALBANIA.setActiveSelect();
			//formsISPALBANIA.stepByStorage();
			formsISPALBANIA.goToNext();
			formsISPALBANIA.goBackStep();
			formsISPALBANIA.plusMinus();
			if ($("#privacystatus").length > 0) {
				formsISPALBANIA.checkPrivacy();
			}
			formsISPALBANIA.initStep();
			formsISPALBANIA.writeInput();
			
			// formsISPALBANIA.checkMobileOrDesktopQuestionOne();
		}

	};

	
	/* --------------------- */
	
	
	
	// SET MAGNIFICA CSS
	this.setMagnificaCss = function() {

		var thisPageLink = window.location.pathname;
		
		if(thisPageLink.toLowerCase().includes("magnifica")){
	    	// var magnificaCss = $(".mortgageContainerPage").attr("data-magnifica-css");
	    	// $('[rel="preload stylesheet"][as="font"]').attr("href", magnificaCss);
	    	
	    	$(".r-btn-nextMortgage").each(function () {
				$(this).addClass("nextButtonMagnifica");
			})
			
			$(".r-progress-bar-fillMortgage").each(function () {
				$(this).addClass("r-progress-bar-fill-magnifica");
			})
			
			$(".rtitle-accordotionMortgage").each(function () {
				$(this).addClass("rtitle-accordotion-magnifica");
			})
			
			$(".buttonPlusMinusMortgage").each(function () {
				$(this).addClass("plusMinusButtonMagnifica");
			})
			
			$(".loanCalculator__close_mortgage").each(function () {
				$(this).addClass("loanCalculator__close_mortgage_magnifica");
			})
	    	
	    }
	}
	
	
	this.setProductName = function(){
		var productName = formsISPALBANIA.sessionMortgage[0]['form1']['productName'];
		if(productName != null ){
			var arr = productName.split(" ");
	
			for (var i = 0; i < arr.length; i++) {
			    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
			}
	
			var finalProductName = arr.join(" ");
			
			if ($(".productName").length > 0) {
				$(".productName").each(function () {
					var thistitle = $(this).html();
					thistitle = thistitle.replace("${productName}", finalProductName);
					$(this).html(thistitle);
				})
			}
		}
	}
	
	
	
	this.checkMobileOrDesktopQuestionOne = function (){
		var step = formsISPALBANIA.getStep();
		var dataStepNew = parseInt(step);
		var myForm = $('input[name="myForm"]').val();
		
		if(myForm == 'form1' && dataStepNew == 1){
			$('#submit').addClass('mobileVersion');
			$('#previous').addClass('desktopVersion');
		}
		else{
			$('#submit').removeClass('mobileVersion');
			$('#previous').removeClass('desktopVersion');
		}
	}
	
	
	
	this.freeEmptyField = function () {
		var step = formsISPALBANIA.getStep();
		var dataStepNew = parseInt(step);
		var myForm = $('input[name="myForm"]').val();
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('input:hidden').each(function (idx) {
			var name = this['name'];
			var type = this['type'];
			if(formsISPALBANIA.sessionMortgage[0][myForm][name]){
				formsISPALBANIA.sessionMortgage[0][myForm][name] = '';
			}
			if(type == 'radio'){
				$(".rstepwrapper").eq(dataStepNew - 1).find('input:hidden').eq(idx).parent().removeClass('active');
				this['checked'] = false;
			}
			else{
				this['value'] = '';
			}
		});
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('select:hidden').each(function () {
			var name = this['name'];
			if(formsISPALBANIA.sessionMortgage[0][myForm][name]){
				formsISPALBANIA.sessionMortgage[0][myForm][name] = '';
			}
			if( $(this).parents().hasClass('mortgage_currency_select') ) {
			    $(this).val($("option:first", this).val());
			}
			else{
				this['value'] = '';
			}
			$(this).removeClass("fc-edited");
		});
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('[data-val]:hidden').each(function (idx) {
			var name = $(this).attr("name");
			if(formsISPALBANIA.sessionMortgage[0][myForm][name]){
				formsISPALBANIA.sessionMortgage[0][myForm][name] = '0';
			}
			
		});
	}
	
	
	
	this.setNextActiveCheckingFields = function (step) {
		var compiled = true;
		var dataStepNew = parseInt(step);
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('input:visible').each(function () {
			var type = this['type'];
			if(!$(this).hasClass("mortgage-input-optional")){
				if(type == 'radio'){
					var name = this['name'];
					if($(".rstepwrapper").eq(dataStepNew - 1).find("input[name=" + name + "]:checked").length == 0){
						compiled = false;
					}
				}
				else{
					if(this['value'] == "" || this['value'] == null ||this['value'] == undefined){
						compiled = false;
					}
				}
				}
		});
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('select:visible').each(function () {
			if(this['value'] == "" || this['value'] == null ||this['value'] == undefined){
				compiled = false;
			}
		});
		
		if(compiled){
			if($(".parsley-custom-error-message:visible").length > 0){
				formsISPALBANIA.disableNext($('button.r-btn-next'));
			}
			else{
				formsISPALBANIA.setActiveNext($('button.r-btn-next'));
			}
		}
		else{
			formsISPALBANIA.disableNext($('button.r-btn-next'));
		}
	}
	
	
	
	/*this.scoreFunction = function () {
		var myForm = $('input[name="myForm"]').val();
		var dataStepNew = formsISPALBANIA.getStep() - 1;
		if(myForm == 'form1' && dataStepNew == 2){
			formsISPALBANIA.score1 = parseInt($(".rstepwrapper").eq(dataStepNew - 1).find('input:checked').attr('js-data-score'));
			sessionStorage.setItem('score1', JSON.stringify(formsISPALBANIA.score1));
		}
		
		if(myForm == 'form2' && dataStepNew == 1){
			var value = parseInt($(".rstepwrapper").eq(dataStepNew - 1).find('.js-data-score').val().replace(/[^0-9]/g, ''));
			var currency = $(".rstepwrapper").eq(dataStepNew - 1).find('[name="monthlyIncomeCurrency"]').val();
			if((currency == "LEK" && value < 50000) ||
			   (currency == "EUR" && value < 450) ||
			   (currency == "USD" && value < 450) ||
			   (currency == "GBP" && value < 450) ||
			   (currency == "CHF" && value < 450)){
				formsISPALBANIA.score2 = 1;
			}
			else if((currency == "LEK" && value >= 50000 && value < 80000) ||
				    (currency == "EUR" && value >= 450 && value < 750) ||
				    (currency == "USD" && value >= 450 && value < 750) ||
				    (currency == "GBP" && value >= 450 && value < 750) ||
				    (currency == "CHF" && value >= 450 && value < 750)){
				formsISPALBANIA.score2 = 2;
			}
			else if((currency == "LEK" && value >= 80000) ||
				    (currency == "EUR" && value >= 750) ||
				    (currency == "USD" && value >= 750) ||
				    (currency == "GBP" && value >= 750) ||
				    (currency == "CHF" && value >= 750)){
				formsISPALBANIA.score2 = 3;
			}
			sessionStorage.setItem('score2', JSON.stringify(formsISPALBANIA.score2));
		}
		
		var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON');
		var JSON_Obj = sessionStorageMortgage ? JSON.parse(sessionStorageMortgage) : {};
		JSON_Obj[0].score = formsISPALBANIA.score1 + formsISPALBANIA.score2;
		sessionStorage.setItem('mortgageJSON', JSON.stringify(JSON_Obj));
	} */
	
	
	
	this.writeInput = function () {
		var arrInput = Array.from($('.control-input-mortgage'))
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		var myForm = $('input[name="myForm"]').val();
		var JSON_Obj = sessionJSON ? JSON.parse(sessionJSON) : {};
		
		if(myForm === "form4"){
			if($('[name="partner"]').length > 0){
				var itemList = $('[name="partner"]').attr("data-partner-itemlist");
				var itemArray = itemList.split("<br/>");
				var totalNumberOfItem = itemArray.length;
				for(i=0; i < totalNumberOfItem; i++){
					var singleElement = itemArray[i];
					if(totalNumberOfItem == 1){
						$('#selector-partner-mortgage').append('<option value="' + singleElement + '" selected="selected">' + singleElement + '</option>');
						$('#selector-partner-mortgage').prop('disabled', 'disabled');
						$('#selector-partner-mortgage').val(singleElement);
						$('#selector-partner-mortgage').trigger("change");
					}
					else{
						$('#selector-partner-mortgage').append('<option value="' + singleElement + '">' + singleElement + '</option>');
						$('#selector-partner-mortgage').val("");
					}
				}
			}
		}
		
		if (JSON_Obj && JSON_Obj[0]){
			arrInput.forEach(function (input) {
				var name = input.name;
				if(JSON_Obj[0][myForm][name]['length'] > 0){
					if (input['type'] == "radio") {
						if(input['name'] == name && input['value'] == JSON_Obj[0][myForm][name]){
							input.click();
						}
					}
					else{
						input['value'] = JSON_Obj[0][myForm][name];
						if(name == "mortgageBirthDate"){
							$(".dataPickerContainerMortgage").addClass("fc-edited");
						}
						$('[name="' + name + '"]').addClass("fc-edited");
					}
				}
			})
			
			var arrSelect = Array.from($('.rcontainer-select'));
			arrSelect.forEach(function (select) {
				var name = select.name;
				if(JSON_Obj[0][myForm][name]['length'] > 0){
					$(select).val(JSON_Obj[0][myForm][name]);
					$(select).addClass("fc-edited");
					$(select).trigger("change");
				}else{
					if($(select).val() == null || $(select).val() == undefined){
						formsISPALBANIA.sessionMortgage[0][myForm][name] = "";
					}
					else{
						formsISPALBANIA.sessionMortgage[0][myForm][name] = $(select).val();
						$(select).addClass("fc-edited");
						$(select).trigger("change");
					}
				}
			})
		}
		
		if(myForm === "form2"){
			var nameHousehold = "householdMembers";
			var valueHousehold = JSON_Obj[0][myForm][nameHousehold];
			$('#' + nameHousehold).html(valueHousehold);
			var maxValueHousehold = parseInt($('[name="' + nameHousehold + '"]').attr("data-maximum"));
			var minValueHousehold = parseInt($('[name="' + nameHousehold + '"]').attr("data-minimum"));
			if(parseInt(valueHousehold) === minValueHousehold){
				$('[name="householdMembersMinus"]').addClass("disabled");
				$('[name="householdMembersPlus"]').removeClass("disabled");
			}
			else if(parseInt(valueHousehold) === maxValueHousehold){
				$('[name="householdMembersMinus"]').removeClass("disabled");
				$('[name="householdMembersPlus"]').addClass("disabled");
			}
			else{
				$('[name="householdMembersMinus"]').removeClass("disabled");
				$('[name="householdMembersPlus"]').removeClass("disabled");
			}
		}
		
		if(sessionStorage.getItem('next')) {
			var step = formsISPALBANIA.getStep();
			formsISPALBANIA.setNextActiveCheckingFields(step);
		}
		
		if(sessionStorage.getItem('back')) {
			formsISPALBANIA.setActiveNext($('button.r-btn-next'));
		}
	}
	
	
	
	this.initStep = function () {
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		var myForm = $('input[name="myForm"]').val();
		
		if (sessionStorage.getItem('back') == 'true') {
			if (myForm == 'form1') {
				$('.rstepwrapper').addClass('rhide');
				var loanPurposeIndex = formsISPALBANIA.sessionMortgage[0]["loanPurposeIndex"];
				if(loanPurposeIndex == "1"){
					$('#numberofsteps').attr("value", "6");
					$(".rstep6-1").addClass("rstep6");
					$(".rstep6-2").removeClass("rstep6");
					$(".rstep6-1").after($(".rstep6-2"));
					$('.rstep6').removeClass('rhide');
					dataNewStep = 6;
				}
				else if(loanPurposeIndex == "2"){
					$('#numberofsteps').attr("value", "6");
					$(".rstep6-1").removeClass("rstep6");
					$(".rstep6-2").addClass("rstep6");
					$(".rstep6-2").after($(".rstep6-1"));
					$('.rstep6').removeClass('rhide');
					dataNewStep = 6;
				}
				else{
					$('#numberofsteps').attr("value", "5");
					$(".rstep6-1").removeClass("rstep6");
					$(".rstep6-2").removeClass("rstep6");
					$('.rstep5').removeClass('rhide');
					dataNewStep = 5;
				}
			}
			if (myForm == 'form2') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep5').removeClass('rhide');
				dataNewStep = 5;
			}
			if (myForm == 'form3') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep2').removeClass('rhide');
				dataNewStep = 2;
			}
			if (myForm == 'form4') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep1').removeClass('rhide');
				dataNewStep = 1;
			}
			
			window.intesa.formsISPALBANIA.setStep(dataNewStep);
			window.intesa.formsISPALBANIA.refreshStep(dataNewStep);
			
		}
		if (sessionStorage.getItem('next') == 'true') {
			$('.rstepwrapper').addClass('rhide');
			$('.rstep1').removeClass('rhide');
			dataNewStep = 1;
			
			window.intesa.formsISPALBANIA.setStep(dataNewStep);
			window.intesa.formsISPALBANIA.refreshStep(dataNewStep);
		}
	}
	
	

	this.stepByStorage = function () {
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form1[key].length > 0 && sessionStorage.getItem('next') != 'true') {
						showStep(key);
						$('input[name="' + key + '"]').each(function () {
							var self = this;
							if ($(self).val() == JSON_Obj[0].form1[key]) {
								$(self).attr('checked', true).parent('label').trigger('click');
							}
						});

						switch (key) {
							case "loanPurpose":
								formsISPALBANIA.setStep(1);
								formsISPALBANIA.refreshStep(1);
								$('.rstep1').removeClass('rhide');
								break;
							case "borrowingProcess":
								formsISPALBANIA.setStep(2);
								formsISPALBANIA.refreshStep(2);
								$('.rstep2').removeClass('rhide');
								break;
							case "permanentAddress":
								formsISPALBANIA.setStep(3);
								formsISPALBANIA.refreshStep(3);
								$('.rstep3').removeClass('rhide');
								break;
							case "adultAge":
								formsISPALBANIA.setStep(4);
								formsISPALBANIA.refreshStep(4);
								$('.rstep4').removeClass('rhide');
								break;
							case "incomeType":
								formsISPALBANIA.setStep(5);
								formsISPALBANIA.refreshStep(5);
								$('.rstep5').removeClass('rhide');
								break;
							case "refinancedLoanAmount":
								formsISPALBANIA.setStep(6);
								formsISPALBANIA.refreshStep(6);
								$('.rstep6').removeClass('rhide');
								break;
							case "investmentAmount":
								formsISPALBANIA.setStep(6);
								formsISPALBANIA.refreshStep(6);
								$('.rstep6').removeClass('rhide');
								break
							default:
								break;
						}
					}
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form2[key].length > 0 && sessionStorage.getItem('next') != 'true') {

						if ($(self).attr('type') != "radio") {
							$('input[name="' + key + '"]').val(JSON_Obj[0].form2[key]);
						}

						var stepNumber = parseInt(formsISPALBANIA.getStep());
						$(".rstepwrapper").eq(stepNumber - 1).find('input[name="' + key + '"]').trigger("keyup");

						switch (key) {
							case "monthlyIncome":
								formsISPALBANIA.setStep(1);
								formsISPALBANIA.refreshStep(1);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep1').removeClass('rhide');
								break;
							case "householdMembers":
								formsISPALBANIA.setStep(2);
								formsISPALBANIA.refreshStep(2);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep2').removeClass('rhide');
								break;
							case "previousLoan":
								formsISPALBANIA.setStep(3);
								formsISPALBANIA.refreshStep(3);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep3').removeClass('rhide');
								break;
							case "creditCard":
								formsISPALBANIA.setStep(4);
								formsISPALBANIA.refreshStep(4);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep4').removeClass('rhide');
								break;
							case "overdraft":
								formsISPALBANIA.setStep(5);
								formsISPALBANIA.refreshStep(5);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep5').removeClass('rhide');
								break;
							default:
								break;
						}
					}
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form3[key].length > 0 && sessionStorage.getItem('next') != 'true') {

						switch (key) {
							case "valueOfProperty":
								formsISPALBANIA.setStep(1);
								formsISPALBANIA.refreshStep(1);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep1').removeClass('rhide');
								break;
							case "collateral":
								formsISPALBANIA.setStep(2);
								formsISPALBANIA.refreshStep(2);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep2').removeClass('rhide');
								break;
							default:
								break;
						}
					}

					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger('focus');
					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger("keyup");

				}
			}
			
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form4) {
				for (var key in JSON_Obj[0].form4) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form4[key].length > 0 && sessionStorage.getItem('next') != 'true') {

						switch (key) {
							case "referralSource":
								formsISPALBANIA.setStep(1);
								formsISPALBANIA.refreshStep(1);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep1').removeClass('rhide');
								break;
							default:
								break;
						}
					}

					$('input[name="' + key + '"]').val(JSON_Obj[0].form4[key]).trigger('focus');
					$('input[name="' + key + '"]').val(JSON_Obj[0].form4[key]).trigger("keyup");

				}
			}
		}
	}


	function showStep(key_obj) {
		$('.rstepwrapper').addClass('rhide');

		if (key_obj.indexOf('One') > -1) {
			$('.rstep1').removeClass('rhide');
			formsISPALBANIA.setStep(1);
			formsISPALBANIA.refreshStep(1);
		}
		if (key_obj.indexOf('Two') > -1) {
			$('.rstep2').removeClass('rhide');
			formsISPALBANIA.setStep(2);
			formsISPALBANIA.refreshStep(2);
		}
		if (key_obj.indexOf('Three') > -1) {
			$('.rstep3').removeClass('rhide');
			formsISPALBANIA.setStep(3);
			formsISPALBANIA.refreshStep(3);
		}
		if (key_obj.indexOf('Four') > -1) {
			$('.rstep4').removeClass('rhide');
			formsISPALBANIA.setStep(4);
			formsISPALBANIA.refreshStep(4);
		}
		if (key_obj.indexOf('Five') > -1) {
			$('.rstep5').removeClass('rhide');
			formsISPALBANIA.setStep(5);
			formsISPALBANIA.refreshStep(5);
		}
		if (key_obj.indexOf('Six') > -1) {
			$('.rstep6').removeClass('rhide');
			formsISPALBANIA.setStep(6);
			formsISPALBANIA.refreshStep(6);
		}
	}



	this.goToNext = function () {
		$(document).on('click', 'button.r-btn-next', function (e) {
			
			formsISPALBANIA.freeEmptyField();

			sessionStorage.removeItem('back');
			sessionStorage.removeItem('next');

			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) + 1;

			var myForm = $('input[name="myForm"]').val();

			sessionStorage.setItem('mortgageJSON', JSON.stringify(formsISPALBANIA.sessionMortgage));

			if (myForm == 'form1') {
				sessionStorage.setItem('mortgageStep', '1');
			}
			if (myForm == 'form2') {
				sessionStorage.setItem('mortgageStep', '2');	
			}
			if (myForm == 'form3') {
				sessionStorage.setItem('mortgageStep', '3');
			}
			if (myForm == 'form4') {
				sessionStorage.setItem('mortgageStep', '4');
			}

			if (dataStepNew > $("#numberofsteps").val()) {
				var myForm = $('input[name="myForm"]').val();
				
				var sessionStorageMortage = sessionStorage.getItem('mortgageJSON') || "";
				if (sessionStorageMortage !== "") {
					if (sessionStorageMortage.length > 0) {
						var JSON_Obj = JSON.parse(sessionStorageMortage);
					}
				}

				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					for (var key in JSON_Obj[0].form1) {
						if (JSON_Obj[0].form1[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
					for (var key in JSON_Obj[0].form2) {
						if (JSON_Obj[0].form2[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
					for (var key in JSON_Obj[0].form3) {
						if (JSON_Obj[0].form3[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form4) {
					for (var key in JSON_Obj[0].form4) {
						if (JSON_Obj[0].form4[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form4[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				
				/*if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].score) {
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="score" value="' + JSON_Obj[0].score + '"/>');
				}*/
				
				$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary').attr('disabled', true);
				$('form[name="formThanksMortgage"]').submit();
				
			} else {
				formsISPALBANIA.disableNext($('button.r-btn-next'));

				var myForm = $('input[name="myForm"]').val();

				if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {

					$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');

				} else {

					formsISPALBANIA.disableNext(self);

				}

				if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').length > 0 && $(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {

					var stepNum = parseInt(formsISPALBANIA.getStep());
					var debitors_num = $(".rstepwrapper").eq(stepNum - 1).find('div[data-val]')[0];
					if(debitors_num && debitors_num != null && debitors_num != undefined){
						if(parseInt(debitors_num.innerText) >= 0){
							//formsISPALBANIA.setActiveNext($('button.r-btn-next'));
							var stepNextActive = formsISPALBANIA.getStep();
							formsISPALBANIA.setNextActiveCheckingFields(stepNextActive);
						}
					}

					$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
						var self = $(this);
						if (self.is(':visible')) {
							self.trigger("keyup");
						}
					});
					
					$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
						var self = $(this);
						if (self.is(':checked')) {
							//self.trigger("click");
							var stepNextActive = formsISPALBANIA.getStep();
							formsISPALBANIA.setNextActiveCheckingFields(stepNextActive);
						}
					});

				} else {
					
					var stepNextActive = formsISPALBANIA.getStep();
					formsISPALBANIA.setNextActiveCheckingFields(stepNextActive);
					//formsISPALBANIA.disableNext($('button.r-btn-next'));
				}
				
				var step = formsISPALBANIA.getStep();
				var dataStepNew2 = parseInt(step);
				if ($(".rstepwrapper").eq(dataStepNew2 - 1).find('input[data-ok]:checked').hasClass("not_eligible")) {
					window.location.replace($("#submit").attr("data-redirect-not-eligible"));
				}
				else{
					formsISPALBANIA.refreshStep(dataStepNew);
					formsISPALBANIA.setStep(dataStepNew);

					$('.rstepwrapper').addClass('rhide');
					$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');
				}
				
				/*if ($(".rstepwrapper").eq(dataStepNew - 2).find('input[data-ok]:checked').hasClass("not_eligible")) {
					window.location.replace($("#submit").attr("data-redirect-not-eligible"));
				}*/
				
			}
			
			//formsISPALBANIA.writeInput();
			// formsISPALBANIA.checkMobileOrDesktopQuestionOne();

			formsISPALBANIA.scrollToTop();
			
			var step = parseInt(formsISPALBANIA.getStep());
			formsISPALBANIA.setNextActiveCheckingFields(step);
			//formsISPALBANIA.scoreFunction();

			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
			
			if ($(".rstepwrapper").eq(dataStepNew - 2).find('input[data-ok]:checked:visible').hasClass("not_eligible")) {
				window.location.replace($("#submit").attr("data-redirect-not-eligible"));
			}
			else{
				if (dataStepNew > $("#numberofsteps").val()) {
					sessionStorage.setItem('next', "true");
					
			        $('.r-btn-nextMortgage')[0].innerHTML = '<span><img class="loading-mortgage" width="22" height="22"></img></span>';
			        $('.r-btn-nextMortgage')[0].disabled = true;
			
					var myForm = $('input[name="myForm"]').val();
					
					// TODO: capire come prendere il valore da controllare
					if (myForm == 'form2' && formsISPALBANIA.sessionMortgage[0].form1.mortgage == 'WITHOUT_MORTGAGE') {
						window.location.replace($("#submit").attr("data-redirect-contact"));
					}
					else{
						window.location.replace($("#submit").attr("data-redirect"));
					}
				}
			}
		});
	};

	//scroll to top
	this.scrollToTop = function () {
		 $('.r-component-wrapper')[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
	}

	//if ($(".r-form-top-section").length > 0) {
	//	formsISPALBANIA.scrollToTop();
	//}

	this.goBackStep = function () {
		$(document).on('click', 'button.r-btn-back', function (e) {
			
			formsISPALBANIA.freeEmptyField();

			sessionStorage.removeItem('next');
			sessionStorage.removeItem('back');
			
			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var myForm = $('input[name="myForm"]').val();
			
			sessionStorage.setItem('mortgageJSON', JSON.stringify(formsISPALBANIA.sessionMortgage));

			if (dataStepNew < 1) {
				var gotoform = "";
				var mortgageForm = sessionStorage.getItem('mortgageForm') || "";
				/*if (mortgageForm !== "") {
					mortgageForm = JSON.parse(mortgageForm);

					//if (myForm == 'form1') { gotoform = mortgageForm.form1 }
					if (myForm == 'form1') { gotoform = mortgageForm.landing }
					if (myForm == 'form2') { gotoform = mortgageForm.form1 }
					if (myForm == 'form3') { gotoform = mortgageForm.form2 }

					if (gotoform !== "") {
						sessionStorage.setItem('back', "true");
						window.location.href = gotoform;
					}
				}*/
				if (myForm !== 'form1') {
					sessionStorage.setItem('back', "true");
					window.location.replace($("#previous").attr("data-redirect-previous-step"));
				}
				else{
					var loanPage = sessionStorage.getItem('calc');
					window.location.replace(loanPage);
				}
				
				//history.back(1);
			} else {

				formsISPALBANIA.disableNext($('button.r-btn-next'));

				setTimeout(function () {
					if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {
						$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');
					} else {
						formsISPALBANIA.disableNext($('button.r-btn-next'));
					}
	
					if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').length > 0 && $(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {
						var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON'))[0].form2
						
						var stepNum = parseInt(formsISPALBANIA.getStep());
						var debitors_num = $(".rstepwrapper").eq(stepNum - 1).find('div[data-val]')[0];
						if(debitors_num && debitors_num != null && debitors_num != undefined){
							if(parseInt(debitors_num.innerText) >= 0){
								//formsISPALBANIA.setActiveNext($('button.r-btn-next'));
								var stepNextActive = formsISPALBANIA.getStep();
								formsISPALBANIA.setNextActiveCheckingFields(stepNextActive - 1);
							}
						}
	
						// controllo sui radio per attivare il bottone
						$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
							var self = $(this);
							if (self.is(':checked')) {
								//formsISPALBANIA.setActiveNext($('button.r-btn-next'));
								var stepNextActive = formsISPALBANIA.getStep();
								formsISPALBANIA.setNextActiveCheckingFields(stepNextActive - 1);
							}
						});
	
						$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
							var self = $(this);
							if (self.is(':visible')) {
								self.trigger("keyup");
							}
						});
	
					} else {
						//formsISPALBANIA.setActiveNext($('button.r-btn-next'));
						var stepNextActive = formsISPALBANIA.getStep();
						formsISPALBANIA.setNextActiveCheckingFields(stepNextActive - 1);
					}
				}, 100);

				
				formsISPALBANIA.refreshStep(dataStepNew);
				formsISPALBANIA.setStep(dataStepNew);

				$('.rstepwrapper').addClass('rhide');
				$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');

			}
			
			// formsISPALBANIA.checkMobileOrDesktopQuestionOne();

			formsISPALBANIA.scrollToTop();
			//formsISPALBANIA.scoreFunction();
			
			//formsISPALBANIA.writeInput();

			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
		});
	}

	this.formStep1Mortagage = function () {
		formsISPALBANIA.setStep(1);
	}

	//set active input
	this.setActiveInput = function () {
		$(".rcontainer-input").on("click", function () {
			var name = $(this).find('input').attr("name");
			$('[name=' + name + ']').parent().removeClass("active");
			$(this).addClass("active");

			var myForm = $('input[name="myForm"]').val();

			if (myForm == 'form1') {
				var stepNumber = parseInt(formsISPALBANIA.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				if (chekToInput) formsISPALBANIA.sessionMortgage[0].form1[name] = $('[name=' + name + ']:checked').val();
				if(name == "loanPurpose"){
					formsISPALBANIA.sessionMortgage[0]["loanPurposeIndex"] = $("[name='loanPurpose']").index($("[name='loanPurpose']:checked"));
				}
				if(name == "borrowingProcess"){
					formsISPALBANIA.sessionMortgage[0].form1["borrowingProcessFirstPossibility"] = $("#borrowingProcess1").val();
					formsISPALBANIA.sessionMortgage[0].form1["borrowingProcessSecondPossibility"] = $("#borrowingProcess2").val();
					formsISPALBANIA.sessionMortgage[0].form1["borrowingProcessThirdPossibility"] = $("#borrowingProcess3").val();
				}
			}

			if (myForm == 'form2') {
				var stepNumber = parseInt(formsISPALBANIA.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				formsISPALBANIA.sessionMortgage[0].form2[name] = $('[name=' + name + ']:checked').val();
			}

			if (myForm == 'form3') {
				var stepNumber = parseInt(formsISPALBANIA.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				formsISPALBANIA.sessionMortgage[0].form3[name] = $('[name=' + name + ']:checked').val();
			}
			
			if (myForm == 'form4') {
				var stepNumber = parseInt(formsISPALBANIA.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				formsISPALBANIA.sessionMortgage[0].form4[name] = $('[name=' + name + ']:checked').val();
			}

			
			var step = parseInt(formsISPALBANIA.getStep());
			formsISPALBANIA.setNextActiveCheckingFields(step);
			//formsISPALBANIA.showError(formsISPALBANIA.getStep());
		});

	}

	this.setActiveImport = function () {
		$(".rcontainer-import input").on("keyup", function () {
			var self = $(this);
			if (self.val().length > 0) {
				
				var stepNextActive = formsISPALBANIA.getStep();
				formsISPALBANIA.setNextActiveCheckingFields(stepNextActive);


				if ($(".rstepwrapper").eq(parseInt(formsISPALBANIA.getStep()) - 1).find("input").length > 1 && $(".rstepwrapper").eq(parseInt(formsISPALBANIA.getStep()) - 1).find('.rcontainer-import').attr('data-showhideloan') == undefined) {
					$(".rstepwrapper").eq(parseInt(formsISPALBANIA.getStep()) - 1).find("input").each(function () {
						if ($(this).is(':visible') && $(this).val() == '') {
							formsISPALBANIA.disableNext($('button.r-btn-next'));
							return;
						}
					});
				}

				var name = $(this).attr("name");
				var myForm = $('input[name="myForm"]').val();
				
				if (myForm == 'form1') {
					if ($('[name=' + name + ']').attr('type') != "radio" && $('[name=' + name + ']').length > 1) {
						for (var i = 0; i < $('[name=' + name + ']').length; i++) {
							if ($($('[name=' + name + ']')[i]).val() != "") {
								formsISPALBANIA.sessionMortgage[0].form1[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
							}
						}
					} else {
						formsISPALBANIA.sessionMortgage[0].form1[name] = $('[name=' + name + ']').val();
					}
				}

				if (myForm == 'form2') {
					if ($('[name=' + name + ']').attr('type') != "radio" && $('[name=' + name + ']').length > 1) {
						for (var i = 0; i < $('[name=' + name + ']').length; i++) {
							if ($($('[name=' + name + ']')[i]).val() != "") {
								formsISPALBANIA.sessionMortgage[0].form2[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
							}
						}
					} else {
						formsISPALBANIA.sessionMortgage[0].form2[name] = $('[name=' + name + ']').val();
					}
				}

				if (myForm == 'form3') {
					if ($('[name=' + name + ']').length > 1) {
						for (var i = 0; i < $('[name=' + name + ']').length; i++) {
							if ($($('[name=' + name + ']')[i]).val() != "") {
								formsISPALBANIA.sessionMortgage[0].form3[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
							}
						}
					} else {
						formsISPALBANIA.sessionMortgage[0].form3[name] = $('[name=' + name + ']').val();
					}
				}
				
				if (myForm == 'form4') {
					if ($('[name=' + name + ']').length > 1) {
						for (var i = 0; i < $('[name=' + name + ']').length; i++) {
							if ($($('[name=' + name + ']')[i]).val() != "") {
								formsISPALBANIA.sessionMortgage[0].form4[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
							}
						}
					} else {
						formsISPALBANIA.sessionMortgage[0].form4[name] = $('[name=' + name + ']').val();
					}
				}
				
			} else {
				formsISPALBANIA.disableNext($('button.r-btn-next'));
			}
		});
	}
	
	//set active select
	this.setActiveSelect = function () {
		$(".rcontainer-select").on("change", function () {
			var name = $(this).attr("name");

			var myForm = $('input[name="myForm"]').val();

			if (myForm == 'form1') {
				formsISPALBANIA.sessionMortgage[0].form1[name] = $('[name=' + name + ']').val();
			}

			if (myForm == 'form2') {
				formsISPALBANIA.sessionMortgage[0].form2[name] = $('[name=' + name + ']').val();
			}

			if (myForm == 'form3') {
				formsISPALBANIA.sessionMortgage[0].form3[name] = $('[name=' + name + ']').val();
			}
			
			if (myForm == 'form4') {
				formsISPALBANIA.sessionMortgage[0].form4[name] = $('[name=' + name + ']').val();
			}

			
			var step = parseInt(formsISPALBANIA.getStep());
			formsISPALBANIA.setNextActiveCheckingFields(step);
		});

	}

	//refresh the step progress
	this.refreshStep = function (step) {
		var myForm = $('input[name="myForm"]').val();
		
		var loanPurposeIndex = formsISPALBANIA.sessionMortgage[0]["loanPurposeIndex"];
		
		if(loanPurposeIndex == "1"){
			totalSteps = 14;
		}
		else if(loanPurposeIndex == "2"){
			totalSteps = 14;
		}
		else{
			totalSteps = 13;
		}
		
		if (myForm == 'form1') {
			if(loanPurposeIndex == "1"){
				formsISPALBANIA.sessionMortgage[0]["form1"]["investmentAmount"] = "";
				$("[name='investmentAmount']").val("");
				$('#numberofsteps').attr("value", "6");
				$(".rstep6-1").addClass("rstep6");
				$(".rstep6-2").removeClass("rstep6");
				$(".rstep6-1").after($(".rstep6-2"));
			}
			else if(loanPurposeIndex == "2"){
				formsISPALBANIA.sessionMortgage[0]["form1"]["refinancedLoanAmount"] = "";
				$("[name='refinancedLoanAmount']").val("");
				$('#numberofsteps').attr("value", "6");
				$(".rstep6-1").removeClass("rstep6");
				$(".rstep6-2").addClass("rstep6");
				$(".rstep6-2").after($(".rstep6-1"));
			}
			else{
				formsISPALBANIA.sessionMortgage[0]["form1"]["refinancedLoanAmount"] = "";
				formsISPALBANIA.sessionMortgage[0]["form1"]["investmentAmount"] = "";
				$("[name='refinancedLoanAmount']").val("");
				$("[name='investmentAmount']").val("");
				$('#numberofsteps').attr("value", "5");
				$(".rstep6-1").removeClass("rstep6");
				$(".rstep6-2").removeClass("rstep6");
			}
		}

		if (myForm == 'form2') {
			if(loanPurposeIndex == "1"){
				step += 6;
			}
			else if(loanPurposeIndex == "2"){
				step += 6;
			}
			else{
				step += 5;
			}
		}

		if (myForm == 'form3') {
			if(loanPurposeIndex == "1"){
				step += 11;
			}
			else if(loanPurposeIndex == "2"){
				step += 11;
			}
			else{
				step += 10;
			}
		}
		
		if (myForm == 'form4') {
			if(loanPurposeIndex == "1"){
				step += 13;
			}
			else if(loanPurposeIndex == "2"){
				step += 13;
			}
			else{
				step += 12;
			}
			if(step === totalSteps){
				var lastNextLabel = $("[name=lastQuestionMortgage]").attr("data-last-question");
				$("[name=lastQuestionMortgage]").html(lastNextLabel);
			}
			else{
				var notLastNextLabel = $("[name=lastQuestionMortgage]").attr("data-notlast-question");
				$("[name=lastQuestionMortgage]").html(notLastNextLabel);
			}
		}

		if ((step !== null) && (step !== "") && (step !== undefined)) {
			$(".r-cur-step").text(step);
			if ((totalSteps !== null) && (totalSteps !== "") && (totalSteps !== undefined)) {
				$(".r-tot-step").text(totalSteps);
				$(".r-progress-bar-fill").width(parseInt(step) / parseInt(totalSteps) * 100 + "%");
			}
		}
		formsISPALBANIA.scrollToTop();
	}

	//set button next active
	this.setActiveNext = function (thisBtn) {
		thisBtn.addClass("active").prop("disabled", false);
	}

	//disable button next
	this.disableNext = function (thisBtn) {
		thisBtn.removeClass("active").prop("disabled", true);
	}

	//get the current step number
	this.getStep = function () {
		var stepNumber = $('button.r-btn-next').attr('data-step');
		return stepNumber;
	}

	//show the error msg
	this.showError = function (stepNumber) {
		stepNumber = parseInt(stepNumber);
		var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok]").is(":checked") || false;
		if (curstepwrapper || curstepwrapper == "true") {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").addClass('rhide'); //hide the error
			//formsISPALBANIA.setActiveNext($('button.r-btn-next'));
			var stepNextActive = formsISPALBANIA.getStep();
			formsISPALBANIA.setNextActiveCheckingFields(stepNextActive);
		} else {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").removeClass('rhide'); //show the error
			formsISPALBANIA.disableNext($('button.r-btn-next'));
		}

	}

	//set the current step number
	this.setStep = function (stepNumber) {
		$(".r-form-submit-wrapper button").attr("data-step", stepNumber);
		formsISPALBANIA.refreshStep(stepNumber);
	}

	//toggle form accordion
	this.toggleAccordion = function () {

		$('[data-accordion="title"]').on("click", function () {

			$(this).addClass("rhide");
			$(this).next('[data-accordion="detail"]').removeClass("rhide");

		});

		$('[data-accordion="detail"] .rtitle-accordotion').on("click", function () {

			$(this).parent().addClass("rhide");
			$(this).parent().prev('[data-accordion="title"]').removeClass("rhide");

		});

	}
	

	//plus minus
	this.plusMinus = function (val) {

		if ($("[data-plusminus]").length > 0) {

			$("[data-plusminus]").each(function (index, elem) {

				if ((val !== null) && (val !== undefined) && (val !== "")) {
					$(elem).find("[data-val]").text(val);
				}

				var thisMax = $(elem).attr("data-maximum");

				var curVal = $(elem).find("[data-val]").text();
				var thisMinus = $(elem).find("[data-minus]");
				var thisPlus = $(elem).find("[data-plus]");


				thisMinus.removeClass("disabled");
				thisPlus.removeClass("disabled");
				if (curVal == "1") {
					thisMinus.addClass("disabled");
				}

				if (curVal == thisMax) {
					thisPlus.addClass("disabled");
				}

			});
		}
	}

	
	this.setStartingPage = function () {
		
		var loanLnk;
		var previousPage = document.referrer;
		var thisPageLink = window.location.pathname;
		
		if(!previousPage.includes("retail")){
			var defaultRetail = $("[name=linkDefaultRetailMortgage]").attr("data-mortgage-link-default-retail");
			loanLnk = defaultRetail;
		}
		else {
			loanLnk = previousPage;
		}
		
		sessionStorage.setItem('calc', loanLnk);
		
	}
	

	//Open form mortgage
	$("[data-openmortgageform]").on("click", function () {

		formsISPALBANIA.getInputs();

		var calcLnk = window.location.pathname;
		sessionStorage.setItem('calc', calcLnk);
		
		// window.location.replace($('[data-openmortgageform]').attr("data-mortgage-link"));

	});
	
	
	$(".loanLink").click(function () {
		var loanLnk = sessionStorage.getItem('calc');
	    this['href'] = loanLnk;
	})

	//get inputs for the form
	this.getInputs = function () {

		var tenor = "" + window.intesa.loan_calculator_albania.tenorCalculatedPromo || "";
		var loanAmount = "" + window.intesa.loan_calculator_albania.loanAmountResultStandard || "";
		var currency = "" + window.intesa.loan_calculator_albania.currency || "";
		var interestRateType = "" + window.intesa.loan_calculator_albania.selectedInterestRateValue || "";
		var firstInterestRate = "" + window.intesa.loan_calculator_albania.interestRateFirstPeriod || "";
		var secondInterestRate = "" + window.intesa.loan_calculator_albania.interestRateRemainingPeriod || "";
		var installmentFirstPeriod = "" + window.intesa.loan_calculator_albania.monthlyInstallmentResultStandard || "";
		var installmentSecondPeriod = "" + window.intesa.loan_calculator_albania.monthlyInstallmentResultStandard2 || "";
		var amountToRepay = "" + window.intesa.loan_calculator_albania.amountToRepayResultStandard || "";

		var productName = $("[name=fProductName]").val() || "";
		var productId = $("[name=fProductId]").val() || "";

		formsISPALBANIA.sessionMortgage[0].form1.loanAmount = loanAmount || '';
		formsISPALBANIA.sessionMortgage[0].form1.currency = currency || '';
		formsISPALBANIA.sessionMortgage[0].form1.tenor = tenor || '';
		formsISPALBANIA.sessionMortgage[0].form1.interestRateType = interestRateType || '';
		formsISPALBANIA.sessionMortgage[0].form1.firstInterestRate = firstInterestRate || '';
		formsISPALBANIA.sessionMortgage[0].form1.secondInterestRate = secondInterestRate || '';
		formsISPALBANIA.sessionMortgage[0].form1.installmentFirstPeriod = installmentFirstPeriod || '';
		formsISPALBANIA.sessionMortgage[0].form1.installmentSecondPeriod = installmentSecondPeriod || '';
		formsISPALBANIA.sessionMortgage[0].form1.amountToRepay = amountToRepay || ''

		formsISPALBANIA.sessionMortgage[0].form1.productId = productId || '';
		formsISPALBANIA.sessionMortgage[0].form1.productName = productName || '';
		
		sessionStorage.setItem('mortgageJSON', JSON.stringify(formsISPALBANIA.sessionMortgage));

	}

	//show hide elements
	this.showHideElements = function (val) {

		if ((val !== null) && (val !== undefined) && (val !== "")) {

			var stepNumber = formsISPALBANIA.getStep();
			var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1);
			curstepwrapper.find(".mod-hom1").addClass("rhide");
			val = parseInt(val);

			for (i = 0; i <= val - 1; i++) {
				curstepwrapper.find(".mod-hom1").eq(i).removeClass("rhide");
			}

			if (val > 0) {
				//formsISPALBANIA.setActiveNext($('button.r-btn-next'));
				var stepNextActive = formsISPALBANIA.getStep();
				formsISPALBANIA.setNextActiveCheckingFields(stepNextActive);
			}
			if ($(".rstepwrapper").eq(parseInt(formsISPALBANIA.getStep()) - 1).find("input").length > 1) {
				$(".rstepwrapper").eq(parseInt(formsISPALBANIA.getStep()) - 1).find("input").each(function () {
					if (($(this).is(':visible') && $(this).val() == '')) {

						if (!isCIB && formsISPALBANIA.getStep() == 2) {
							//formsISPALBANIA.setActiveNext($('button.r-bth-next'));
							var stepNextActive = formsISPALBANIA.getStep();
							formsISPALBANIA.setNextActiveCheckingFields(stepNextActive);
						}
						formsISPALBANIA.disableNext($('button.r-btn-next'));
						return;
					}
				});
			}
		}

	}

	/*this.resetForms2 = function (thisVal) {
		if (parseInt(thisVal) - 1 == 0) {
			$('input[name="debitorIncomeOne"]').val('');
			formsISPALBANIA.sessionMortgage[0].form2.debitorIncomeOne = "";
		}
		if (parseInt(thisVal) - 1 == 1) {
			$('input[name="debitorIncomeTwo"]').val('');
			formsISPALBANIA.sessionMortgage[0].form2.debitorIncomeTwo = "";
		}
	}*/

	//decrease Value
	$("[data-minus]").on("click", function () {
		var thisCounter = $(this).next("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) - 1);
			var nameVariable = $("[data-val]:visible").attr("name");
			formsISPALBANIA.sessionMortgage[0].form2[nameVariable] = String(parseInt(thisVal) - 1);
			formsISPALBANIA.plusMinus();

			//formsISPALBANIA.showHideElements(parseInt(thisVal) - 1);

			/*if ($('input[name="debitorIncomeOne"]').length > 0) {
				formsISPALBANIA.resetForms2(thisVal);
			}*/
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});


	var elem = $('.rcontainer-import')
	//show/hide loan form2
	$("[data-showloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").removeClass("rhide");
		
		if($("[data-val]:visible").length > 0){
			var nameVariable = $("[data-val]:visible").attr("name");
			var value = formsISPALBANIA.sessionMortgage[0].form2[nameVariable];
			$("[data-val]:visible").html(value);
			if(value === "0"){
				$("[data-minus]:visible").addClass("disabled");
			}
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});
	$("[data-showloan-second]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan-second]").removeClass("rhide");
		
		if($("[data-val]:visible").length > 0){
			var nameVariable = $("[data-val]:visible").attr("name");
			var value = formsISPALBANIA.sessionMortgage[0].form2[nameVariable];
			$("[data-val]:visible").html(value);
			if(value === "0"){
				$("[data-minus]:visible").addClass("disabled");
			}
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});
	$("[data-showloan-third]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan-third]").removeClass("rhide");
		
		if($("[data-val]:visible").length > 0){
			var nameVariable = $("[data-val]:visible").attr("name");
			var value = formsISPALBANIA.sessionMortgage[0].form2[nameVariable];
			$("[data-val]:visible").html(value);
			if(value === "0"){
				$("[data-minus]:visible").addClass("disabled");
			}
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});
	$("[data-show-promo]").on("change", function () {
		$(this).parents(".rcontainer-import").find("[data-showhidepromo]").removeClass("rhide");		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});
	$("[data-hideloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").addClass("rhide").find("input"); //.val("")
		if (myForm == 'form2') {
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var insertedValueName = $(".rstepwrapper").eq(dataStepNew - 1).find('input[data-format-currency').attr('name');
			$(".rstepwrapper").eq(dataStepNew - 1).find('input[name="' + insertedValueName + '"]').trigger("keyup");
			var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON') || "")[0].form2;
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});
	$("[data-hideloan-second]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan-second]").addClass("rhide").find("input"); //.val("")
		if (myForm == 'form2') {
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var insertedValueName = $(".rstepwrapper").eq(dataStepNew - 1).find('input[data-format-currency').attr('name');
			$(".rstepwrapper").eq(dataStepNew - 1).find('input[name="' + insertedValueName + '"]').trigger("keyup");
			var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON') || "")[0].form2;
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});
	$("[data-hideloan-third]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan-third]").addClass("rhide").find("input"); //.val("")
		if (myForm == 'form2') {
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var insertedValueName = $(".rstepwrapper").eq(dataStepNew - 1).find('input[data-format-currency').attr('name');
			$(".rstepwrapper").eq(dataStepNew - 1).find('input[name="' + insertedValueName + '"]').trigger("keyup");
			var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON') || "")[0].form2;
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});

	//increase Value
	$("[data-plus]").on("click", function () {

		var thisCounter = $(this).prev("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) + 1);
			var nameVariable = $("[data-val]:visible").attr("name");
			formsISPALBANIA.sessionMortgage[0].form2[nameVariable] = String(parseInt(thisVal) + 1);
			
			formsISPALBANIA.plusMinus();

			//formsISPALBANIA.showHideElements(parseInt(thisVal) + 1);

			if (isCIB) {
				if (parseInt(thisVal) + 1 == 1) {
					$('input[name="debitorIncomeOne"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 2) {
					$('input[name="debitorIncomeTwo"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 3) {
					$('input[name="debitorIncomeThree"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 4) {
					$('input[name="debitorIncomeFour"]').trigger('keyup');
				}
			}
		}
		
		var step = parseInt(formsISPALBANIA.getStep());
		formsISPALBANIA.setNextActiveCheckingFields(step);
	});

	//set selected label as active
	$(".r-thankyou-time label").on("click", function () {
		$(".r-thankyou-time label").removeClass("active");
		$(this).addClass("active");
	});

	//accept only numbers
	$(document).on("input", ".r-thankyou-wrapper [name='phoneCountryPrefix'], .r-thankyou-wrapper [name='phoneNumber']", function (e) {
		$(this).val($(this).val().replace(/[^0-9]/g, ''));//allow only numbers
	});

	//check success form privacy status
	this.checkPrivacy = function () {
		var item_thanksName = "none";
		if ($("#item_thanksName").length > 0) {
			item_thanksName = $("#item_thanksName").val();
		}
		var checkCaptcha = $("input[name='recaptchaKey']").length >= 1 || "" != $(".g-recaptcha-response").val() ? true : false;
		const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		const reName = /^[a-zA-ZÁÉÚŰŐÓÜÖÍáéúűőóüöíčćšžđČĆŠŽĐ \- \\s.]*$/;
		if (($("#privacystatus").is(":checked")) && ($("#item_email").val() !== "") && (re.test($("#item_email").val())) 
				&& (item_thanksName !== "") && (reName.test(item_thanksName))
			&& ($('[name="phoneCountryPrefix"]').val() !== "") && ($('[name="phoneNumber"]').val() !== "") && ($('[name="phoneNumber"]:visible').parsley().validate()==true)
			&& (checkCaptcha)) {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", false);
		} else {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", true);
		}
	}


	//change btn status after privacy changes
	$("#privacystatus").on("click", function () {
		formsISPALBANIA.checkPrivacy();
	});

	$(".r-thankyou-wrapper input").on("change input", function (e) {
		formsISPALBANIA.checkPrivacy();
	});
	
	$("[name='formThanksMortgage'] #idField-prefix").on("click", function (e) {
		$('[name="phoneCountryPrefix"]').focus();
		$('[name="phoneCountryPrefix"]').click();
	});


	//validate on focus out
	$('.r-thankyou-content input[required]').on("focusout blur", function () {
		$(this).parsley().validate();
	});


	//submit form success
	$(".r-thankyou-wrapper .j-privacy__btn").on("click", function (e) {

		e.preventDefault();

		//check parsley first
		var isformok = $('form[name="formThanksMortgage"]').parsley().validate();
		if (isformok) {

			// get all the inputs into an array.
			var $inputs = $('.r-thankyou-content :input');

			$inputs.each(function () {

				if ($(this).attr('name') !== undefined) {

					var vall = $(this).val() || "";
					var namee = $(this).attr('name') || "";

					if (namee == "privacystatus") {
						if ($(this).is(":checked")) {
							vall = "true";
						} else {
							vall = "false";
						}
					}

					if (namee == "radioTime") {
						if ($(this).is(":checked")) {
							$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
							$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
						} else {
							//
						}
						//
					} else {
						$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
						$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
					}

				}


			});
			
			var sessionStorageMortage = sessionStorage.getItem('mortgageJSON') || "";
			if (sessionStorageMortage !== "") {
				if (sessionStorageMortage.length > 0) {
					var JSON_Obj = JSON.parse(sessionStorageMortage);
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if (JSON_Obj[0].form1[key].length > 0 && key != "personalLoanConfiguration" ) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						if(key != "personalLoanConfiguration"){
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if(JSON_Obj[0].form1.personalLoanConfiguration != undefined){
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="personalLoanConfiguration" value=""/>');
					$('form[name="formThanksMortgage"] input[name="personalLoanConfiguration"]').val(JSON.stringify(JSON_Obj[0].form1.personalLoanConfiguration).toString());
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if (JSON_Obj[0].form2[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if (JSON_Obj[0].form3[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form4) {
				for (var key in JSON_Obj[0].form4) {
					if (JSON_Obj[0].form4[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form4[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			
			/*if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].score) {
				var scoreSum = JSON_Obj[0].score;
				var priority = "";
				if(scoreSum <= 3){
					priority = 'Low Priority (' + scoreSum + ' of 6)'; 
				}
				if(scoreSum > 3 && scoreSum <= 5){
					priority = 'Medium Priority (' + scoreSum + ' of 6)'; 
				}
				if(scoreSum >= 6){
					priority = 'High Priority (' + scoreSum + ' of 6)'; 
				}
				
				$('form[name="formThanksMortgage"]').append('<input type="hidden" name="score" value="' + scoreSum + '"/>');
				$('form[name="formThanksMortgage"]').append('<input type="hidden" name="priorityMortgage" value="' + priority + '"/>');
			}*/
			
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].typeOfAppointment) {
				var typeOfAppointment = JSON_Obj[0].typeOfAppointment;
				
				$('form[name="formThanksMortgage"]').append('<input type="hidden" name="typeOfAppointment" value="' + typeOfAppointment + '"/>');
			}

			// var linkThisPage = window.location.href;
			
			// $('form[name="formThanksMortgage"]').append('<input type="hidden" name="sourceUrl" value="' + linkThisPage + '"/>');
			
			$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary')[0].innerHTML = '<span><img class="loading-mortgage" width="22" height="22"></img></span>';
			$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary').attr('disabled', true);
			$('form[name="formThanksMortgage"]').submit();

		}
		
		//window.location.replace($("#submitMortgage").attr("data-redirect"));

		return false;


	});

	//delete sessionstorage if form is successfully sent
	if ($("[data-formsent]").length > 0) {
		sessionStorage.removeItem('mortgageJSON');
		sessionStorage.removeItem('mortgageStep');
	}

	//on resize, reset the wallpaper
	function resizedw() {
		if ($("[data-bgimg]").length > 0) {
			$("[data-bgimg]").each(function () {
				var imageUrl = $(this).attr("data-bgimg");
				$(this).css('background-image', 'url(' + imageUrl + ')');
			});
		}
	}

	var doit;
	window.onresize = function () {
		clearTimeout(doit);
		doit = setTimeout(resizedw, 10);
	};

	//replace placeholder in mortgage title
	var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON') || "";
	if (sessionStorageMortgage.length > 0) {
		var JSON_Obj = JSON.parse(sessionStorageMortgage);
		var placeholder = JSON_Obj[0].form1["productName"] || "";
		if ($(".r-title").length > 0) {
			$(".r-title").each(function () {
				var thistitle = $(this).html();
				thistitle = thistitle.replace("${productName}", placeholder);
				$(this).html(thistitle);
			})
		}
	}

	/**
	 * Call to servlet
	 *
	 * @param {*} url
	 * @param {*} form
	 */
	this.callServlet = function (url, form) {

		$.ajax({

			type: "POST",
			data: form.serialize(),
			url: url,
			success: function (data) {

				console.log("success sending form");

			},
			error: function (data) {

				console.log("error sending form");

			}

		});

	};


	/**
	 * Show modal
	 *
	 */
	/*
	this.showModal = function () {

		if ($("[data-show-modal]").length) {

			$("[data-show-modal]").each(function (index, el) {

				if ($(this).attr("data-show-modal") == "true") {

					var modalName = $(this).attr("id");
					$("[data-target='#" + modalName + "']").trigger('click');

				}

			});

		}

	};
	*/
	
	$(document).ready(function() {
		var check = $("#landing-button-mortgage").length > 0;
		if (check){
		    setTimeout(function() {
		    $("#landing-button-mortgage").removeClass("disabled");
		    },1000);
		    
		    $('#landing-button-mortgage').on('click',function(e){
	        	$('#landing-button-mortgage')[0].innerHTML = '<span><img class="loading-mortgage" width="22" height="22"></img></span>';
	        	$('#landing-button-mortgage')[0].disabled = true;
		    });
		    
		}
		
	});

};



/**
 * Get class instance
 *
 */
Intesa.FormsISPALBANIA.getInstance = function () {

	if (!window.intesa) {

		window.intesa = new Object();

	}
	if (!window.intesa.formsISPALBANIA) {

		window.intesa.formsISPALBANIA = new Intesa.FormsISPALBANIA();

	}

	return window.intesa.formsISPALBANIA;

};
      /**
* On DOM ready
*
*/
      // $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {
 
	// init component
	var formsISPALBANIA = Intesa.formsISPALBANIA.getInstance();
	formsISPALBANIA.init();
 
} ); */
